import { Injectable } from '@angular/core';
import { AppBaseService } from '../services/http.service';
import { OPD_API_URL } from '../regproperties/opd-url-properties';
import { map, Observable, of, switchMap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DuplicatePatientDialogComponent } from '../regshared/duplicate-patient-dialog/duplicate-patient-dialog.component';
import { dupicatePatient } from '../enums/configuration-modules.enum';

@Injectable({
    providedIn: 'root'
})
export class DuplicatePatientService {


    constructor(
        private appBaseService: AppBaseService,
        public dialog: MatDialog
    ) { }
    checkForDuplicatePatients(value: any, from: string, isNewBorn: boolean,isUnitWisePatientSearch?:boolean,selectedPatient?): Observable<any> {
        this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);

        const params = new URLSearchParams({
            gender: from === dupicatePatient.dateOfBirth ? value.gender || '' : '',
            identificationId: from === dupicatePatient.identificationNo ? value.identificationId || '' : '',
            mobile: from === dupicatePatient.mobileNumber ? value.mobile || '' : '',
            offset: '0',
            size: '10',
            operation: 'search',
            email: value.email || '',
            uhId: value.uhId || '',
            name: from === dupicatePatient.dateOfBirth ? value.name || '' : '',
            birthDate: (from === dupicatePatient.dateOfBirth || from === dupicatePatient.mobileNumber) ? value.birthDate || '' : '',
            identificationType: from === dupicatePatient.identificationNo ? value.identificationType || '' : '',
        });

        return this.appBaseService
            .getResource(OPD_API_URL.CHECK_DUPLICATE_PATIENT+`${params.toString()}`)
            .pipe(
                switchMap((res: any) => {
                    if(!isUnitWisePatientSearch){
                        if(res.message==="Patient already registered."){
                            if(!selectedPatient){
                             const dialogRef = this.dialog.open(DuplicatePatientDialogComponent, {
                            width: "50%",
                            data: {
                                payload: res.payload,
                                isNewBorn: isNewBorn,
                                from: from,
                                isFromUnotherUnit: res.message === "UHID exists without Patient. Patient Not registered in this unit.",
                            },
                            disableClose: true
                        });
                           return dialogRef.afterClosed().pipe(
                            map((result) => {
                                if (result == "No") {
                                    return result;
                                } else if (result) {
                                    const selected = res.payload.find((element: any) => element.id === result);
                                    return { ...selected, isFromAnotherUnit: false };
                                }
                            }))
                        }else{
                            return of("DUPLICATE");
                        }
                    }else{
                           return of("DUPLICATE");
                    }
                    }else{
                    if (res.message === "Need to register patient first.") {
                        return null;
                    } else if (res.message === "Patient already registered in this unit." ||
                        res.message === "UHID exists without Patient. Patient Not registered in this unit."
                    ) {
                         if(!selectedPatient){
                        const dialogRef = this.dialog.open(DuplicatePatientDialogComponent, {
                            width: "50%",
                            data: {
                                payload: res.payload,
                                isNewBorn: isNewBorn,
                                from: from,
                                isFromUnotherUnit: res.message === "UHID exists without Patient. Patient Not registered in this unit.",
                            },
                            disableClose: true
                        });
                        return dialogRef.afterClosed().pipe(
                            map((result) => {
                                if (result == "No") {
                                    return result;
                                } else if (result) {
                                    const selected = res.payload.find((element: any) => element.id === result);
                                    if (res.message === "UHID exists without Patient. Patient Not registered in this unit.") {
                                        return { ...selected, isFromAnotherUnit: true };
                                    } else {
                                        return { ...selected, isFromAnotherUnit: false };
                                    }
                                }
                                return null;
                            })
                        );
                         }else{
                            return of("DUPLICATE");
                    }
                    } else {
                        return null;
                    }
                }
                })
            );
    }


}
